import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './Newprogram.css';

import mechImg from '../img/aaaservices/VR.webp';
import mecadvance from '../img/aaaservices/virtual.webp';
import roboexpert from '../img/aaaservices/expertrobot.jpg';
import simImg from '../img/aaaservices/slashco-bridle1-2.jpg';
import tollbasic from '../img/aaaservices/toolbasic.jpg';
import tollexpert from '../img/aaaservices/tollexpert.jpg';
import itImg from '../img/aaaservices/Java-Full-Stack-1-600x367.jpg';
import advncejava from '../img/aaaservices/advncejava.jpg';
import javaexpert from '../img/aaaservices/javaexpert.png';
import digitaladvance from '../img/aaaservices/digitaladvance.jpg';
import digitalexpert from '../img/aaaservices/digitalexpert.avif';
import itImg1 from '../img/aaaservices/PY.jpg';
import advancepython from '../img/aaaservices/adancepython.jpg';
import pythonexpert from '../img/aaaservices/pynew.png';
import reactdev from '../img/aaaservices/reactada.jpg';
import fluuterdev from '../img/aaaservices/fluuterdata.jpg';
import springboot from '../img/aaaservices/javaspring.jpg';
import itImg2 from '../img/aaaservices/app-development-banner_33099-1720.avif';
import dfsImg from '../img/aaaservices/F.png';
import OnlyButtonrange from './OnlyButtonrange';

export const webinarData = {
  Mechanical: [
    {
      id: 1,
      title: "Virtual Robotics Webinar",
      subtitle: "Robotics & Automation Trends",
      date: "2025-07-15",
      time: "10:00 AM - 12:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: mechImg,
      link: "/webinar/1",
      level: "basic",
      instructor: "Dr. Rajesh Kumar",
      description: "Join our expert webinar on virtual robotics and automation. Learn about the latest trends, technologies, and career opportunities in robotics.",
      topics: [
        "Introduction to Virtual Robotics",
        "Current Industry Trends",
        "Career Opportunities",
        "Q&A Session"
      ],
      speaker: "Dr. Rajesh Kumar - Robotics Expert",
      seatsAvailable: 35,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 2,
      title: "Industrial Robotics Webinar",
      subtitle: "Advanced Robotics in Manufacturing",
      date: "2025-07-18",
      time: "11:00 AM - 1:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: mecadvance,
      link: "/webinar/2",
      level: "advanced",
      instructor: "Prof. Amit Sharma",
      description: "Discover how industrial robotics is transforming manufacturing. This webinar covers real-world applications, case studies, and future predictions.",
      topics: [
        "Industrial Robotics Applications",
        "Case Studies",
        "Future Technologies",
        "Industry Insights"
      ],
      speaker: "Prof. Amit Sharma - Industrial Automation Expert",
      seatsAvailable: 80,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 3,
      title: "AI Robotics Webinar",
      subtitle: "Future of AI in Robotics",
      date: "2025-07-20",
      time: "2:00 PM - 4:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: roboexpert,
      link: "/webinar/3",
      level: "expert",
      instructor: "Dr. Priya Reddy",
      description: "Explore the future of AI in robotics. Learn about machine learning, computer vision, and autonomous systems in this expert-led webinar.",
      topics: [
        "AI in Robotics",
        "Machine Learning Applications",
        "Computer Vision",
        "Autonomous Systems"
      ],
      speaker: "Dr. Priya Reddy - AI & Robotics Researcher",
      seatsAvailable: 60,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 4,
      title: "Tool & Fixture Design Webinar",
      subtitle: "Fundamentals of Tool Design",
      date: "2025-07-22",
      time: "10:00 AM - 12:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: simImg,
      link: "/webinar/4",
      level: "basic",
      instructor: "Mr. Suresh Patel",
      description: "Join this webinar to learn the fundamentals of tool and fixture design. Perfect for mechanical engineering students and professionals.",
      topics: [
        "Tool Design Basics",
        "Fixture Design Principles",
        "Industry Standards",
        "Practical Applications"
      ],
      speaker: "Mr. Suresh Patel - Tool Design Specialist",
      seatsAvailable: 120,
      webinarType: "Live Session",
      recordingAvailable: true
    }
  ],
  IT: [
    {
      id: 5,
      title: "Java Full Stack Webinar",
      subtitle: "Modern Java Development",
      date: "2025-07-25",
      time: "1:00 PM - 3:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: itImg,
      link: "/webinar/5",
      level: "basic",
      instructor: "Mr. Vikram Singh",
      description: "Learn about modern Java Full Stack development. This webinar covers Spring Boot, React, and modern development practices.",
      topics: [
        "Spring Boot Overview",
        "React.js Integration",
        "Full Stack Best Practices",
        "Career Path"
      ],
      speaker: "Mr. Vikram Singh - Senior Java Developer",
      seatsAvailable: 150,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 6,
      title: "Python Full Stack Webinar",
      subtitle: "Python Web Development",
      date: "2025-07-28",
      time: "10:00 AM - 12:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: itImg1,
      link: "/webinar/6",
      level: "advanced",
      instructor: "Ms. Anita Desai",
      description: "Discover Python Full Stack development with Django and modern technologies. Join this webinar to boost your career.",
      topics: [
        "Django Framework",
        "REST API Development",
        "Modern Web Technologies",
        "Job Market Insights"
      ],
      speaker: "Ms. Anita Desai - Python Expert",
      seatsAvailable: 130,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 7,
      title: "Flutter Development Webinar",
      subtitle: "Cross-Platform App Development",
      date: "2025-07-30",
      time: "11:00 AM - 1:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: fluuterdev,
      link: "/webinar/7",
      level: "basic",
      instructor: "Mr. Karthik Rajan",
      description: "Learn about cross-platform app development with Flutter. This webinar covers key concepts and future of mobile development.",
      topics: [
        "Flutter Overview",
        "Building Cross-Platform Apps",
        "Best Practices",
        "Career Opportunities"
      ],
      speaker: "Mr. Karthik Rajan - Flutter Developer",
      seatsAvailable: 100,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 8,
      title: "React Development Webinar",
      subtitle: "Modern Frontend Development",
      date: "2025-08-01",
      time: "2:00 PM - 4:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: reactdev,
      link: "/webinar/8",
      level: "basic",
      instructor: "Ms. Pooja Gupta",
      description: "Join this webinar to learn about modern React development. Perfect for frontend developers looking to upskill.",
      topics: [
        "React.js Fundamentals",
        "State Management",
        "Hooks & Context API",
        "Industry Trends"
      ],
      speaker: "Ms. Pooja Gupta - React Specialist",
      seatsAvailable: 110,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 9,
      title: "Spring Boot Webinar",
      subtitle: "Backend Development with Spring",
      date: "2025-08-03",
      time: "11:00 AM - 1:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: springboot,
      link: "/webinar/9",
      level: "advanced",
      instructor: "Mr. Suresh Patel",
      description: "Master backend development with Spring Boot. This webinar covers microservices, REST APIs, and enterprise applications.",
      topics: [
        "Spring Boot Framework",
        "RESTful Services",
        "Microservices Architecture",
        "Enterprise Development"
      ],
      speaker: "Mr. Suresh Patel - Backend Architect",
      seatsAvailable: 70,
      webinarType: "Live Session",
      recordingAvailable: true
    },
    {
      id: 10,
      title: "Web Fundamentals Webinar",
      subtitle: "HTML, CSS & JavaScript",
      date: "2025-08-05",
      time: "10:00 AM - 12:00 PM",
      cost: "₹99",
      minPrice: 99,
      maxPrice: 99,
      duration: "2 Hours",
      location: "hyderabad",
      language: "english",
      image: itImg2,
      link: "/webinar/10",
      level: "basic",
      instructor: "Ms. Lakshmi Narayanan",
      description: "Learn the fundamentals of web development in this introductory webinar. Perfect for beginners.",
      topics: [
        "HTML5 Basics",
        "CSS3 Styling",
        "JavaScript Fundamentals",
        "Getting Started in Web Development"
      ],
      speaker: "Ms. Lakshmi Narayanan - Web Developer",
      seatsAvailable: 200,
      webinarType: "Live Session",
      recordingAvailable: true
    }
  ]
};

const BranchFilterComponent = () => {
  const navigate = useNavigate();

  const [selectedBranch, setSelectedBranch] = useState("All");
  const [location, setLocation] = useState("");
  const [language, setLanguage] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("All");

  const getFilteredData = () => {
    let data =
      selectedBranch === "All"
        ? [...webinarData.Mechanical, ...webinarData.IT]
        : webinarData[selectedBranch] || [];

    if (location) {
      data = data.filter((card) => card.location === location);
    }

    if (language) {
      data = data.filter((card) =>
        card.language.toLowerCase().includes(language.toLowerCase())
      );
    }

    if (maxPrice !== "") {
      const max = parseInt(maxPrice);
      data = data.filter((card) => card.minPrice <= max);
    }

    if (selectedLevel !== "All") {
      data = data.filter((card) => card.level === selectedLevel);
    }

    return data;
  };

  const handleCardClick = (webinar) => {
    navigate(`/webinar/${webinar.id}`);
  };

  return (
    <div className="course-container">
      {/* Fixed Sidebar */}
      <div className="course-sidebar">
        <h3 className="course-sidebar-title">Webinar Filters</h3>

        <select
          className="course-select"
          value={selectedBranch}
          onChange={(e) => setSelectedBranch(e.target.value)}
        >
          <option value="All">All Categories</option>
          <option value="Mechanical">Mechanical</option>
          <option value="IT">IT</option>
        </select>

        <select
          className="course-select"
          value={selectedLevel}
          onChange={(e) => setSelectedLevel(e.target.value)}
        >
          <option value="All">All Levels</option>
          <option value="basic">Basic</option>
          <option value="advanced">Advanced</option>
          <option value="expert">Expert</option>
        </select>

        <select className="course-select" value={location} onChange={(e) => setLocation(e.target.value)}>
          <option value="">All Locations</option>
          <option value="hyderabad">Hyderabad</option>
          <option value="bangalore">Bangalore</option>
          <option value="mumbai">Mumbai</option>
          <option value="chennai">Chennai</option>
        </select>

        <select className="course-select" value={language} onChange={(e) => setLanguage(e.target.value)}>
          <option value="">All Languages</option>
          <option value="english">English</option>
          <option value="hindi">Hindi</option>
          <option value="telugu">Telugu</option>
          <option value="tamil">Tamil</option>
        </select>

        <select className="course-select" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)}>
          <option value="">Max Price</option>
          <option value="499">₹499</option>
          <option value="599">₹599</option>
          <option value="699">₹699</option>
          <option value="799">₹799</option>
          <option value="999">₹999</option>
        </select>
        
        <select className="course-select" disabled>
          <option value="">Duration: 2 Hours</option>
        </select>
      </div>

      {/* Cards Section - 4 Cards per row */}
      <div className="course-main-content">
        <div className="course-grid">
          {getFilteredData().map((webinar) => (
            <div
              className="course-card"
              key={webinar.id}
              onClick={() => handleCardClick(webinar)}
            >
              <img className="course-card-image" src={webinar.image} alt={webinar.title} />
              <div className="course-card-content">
                <p className="course-card-title">{webinar.title}</p>
                <p className="course-card-duration">{webinar.duration}</p>
                <p className="course-card-subtitle">{webinar.subtitle}</p>
                <p className="course-card-price">{webinar.cost}</p>
                <div className="course-card-footer">
                  <p className="course-card-language">{webinar.language}</p>
                  <button className="course-card-button">Register Now</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BranchFilterComponent;